import React, { ReactElement } from 'react';

import styled from '@emotion/styled';

import UNSWLogo from './images/UNSW.png';
import WSULogo from './images/WSU.png';
import UTSLogo from './images/UTS.png';
import NewscastleLogo from './images/Newscastle.png';
import CharlesSturrtLogo from './images/CSU.png';
import ACULogo from './images/ACU.svg';
import { InstitutionLogo } from '../../../../components/Marketing/InstitutionLogo/components';

const Container = styled.div`
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 6px;
  display: grid;
  justify-content: space-between;
  margin: 15px 0;
  max-width: 1200px;

  @media only screen and (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
  @media only screen and (max-width: 767px) {
    margin-bottom: 30px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
  @media only screen and (max-width: 400px) {
    img {
      max-width: 100px;
      max-height: 50px;
    }
  }
`;

const LogoBox = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const InstitutionLogos = (): ReactElement => {
  return (
    <Container>
      <LogoBox>
        <InstitutionLogo
          logoUrl={UNSWLogo}
          name="UNSW"
          url="https://www.openlearning.com/unswmoocs"
        />
      </LogoBox>
      <LogoBox>
        <InstitutionLogo
          logoUrl={UTSLogo}
          name="UTS"
          url="https://www.openlearning.com/uts"
        />
      </LogoBox>
      <LogoBox>
        <InstitutionLogo
          logoUrl={NewscastleLogo}
          name="University of Newcastle"
          url="https://www.openlearning.com/university-of-newcastle"
        />
      </LogoBox>
      <LogoBox>
        <InstitutionLogo
          logoUrl={CharlesSturrtLogo}
          name="Charles Sturt University"
          url="https://www.openlearning.com/csu"
        />
      </LogoBox>
      <LogoBox>
        <InstitutionLogo
          logoUrl={WSULogo}
          name="WSU"
          url="https://westernx.edu.au/"
        />
      </LogoBox>
      <LogoBox>
        <InstitutionLogo
          logoUrl={ACULogo}
          name="Australian Catholic University"
          url="https://www.openlearning.com/acu/"
        />
      </LogoBox>
    </Container>
  );
};
